import { CUSTOMDOCUMENT_STATUSES } from 'appconstants';

export default value => {
  if (value === 'SUBMITTED') {
    return CUSTOMDOCUMENT_STATUSES.SUBMITTED;
  } if (value === 'PENDING') {
    return CUSTOMDOCUMENT_STATUSES.PENDING;
  } return CUSTOMDOCUMENT_STATUSES.PENDING;
};
